import { CampaignAPI } from 'api/definitions/slotdates/types';
import { mapSeasonalRanges } from 'redux/modules/slot-dates/utils/mapSeasonalRanges';

const reducer = (state: WtrState, action: { result: CampaignAPI[] }) => {
  const campaigns = action?.result ?? [];

  return {
    ...state,
    campaigns: mapSeasonalRanges(campaigns),
  };
};
export default reducer;
